export default {"src":"/_next/static/media/tech.cb2ab664.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};